import { render, staticRenderFns } from "./RiwayatArsip.vue?vue&type=template&id=85b10da4&scoped=true"
import script from "./RiwayatArsip.vue?vue&type=script&lang=js"
export * from "./RiwayatArsip.vue?vue&type=script&lang=js"
import style0 from "./RiwayatArsip.vue?vue&type=style&index=0&id=85b10da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b10da4",
  null
  
)

export default component.exports